/* global.js version
In front-end liquid code, add data attribute to span/div/whatever that holds the price. A listener in global.js then
uses the same Intl.NumberFormat function as below to format prices. Did this so the formats match.
E.g.  data-shopify-price="{{ product.price }}"
Variants e.g. data-variant-shopify-price="{{ all_products[handle].price }}"
*/

const fullyQualifiedLocale = window.localeInformation.language + '-' + window.localeInformation.country
const currency = window.localeInformation.currency

export default {
  formatPrice (shopifyPrice, withCurrency = true) {
    // NOTE: This function expects Shopify price format, so if shopifyPrice = 1000, then it will return $10
    const returnPrice = new Intl.NumberFormat(fullyQualifiedLocale, { style: 'currency', currency }).format(shopifyPrice / 100)

    return returnPrice
  }
}
